/**
 * 分页mix,具体用法:
 * 1. getData：主页面的查询按钮需要绑定 @change="getData" 方法，主页面不需要写具体实现，该mix已经实现
 * 2. queryList：主页面需要在methods里定义queryList()方法，需要有具体实现(主要是对查询条件的处理，有些页面需要特殊处理)，需要调用mergePage(data)方法来将分页信息加上，getData会去调用该方法
 * 3. 主页面分页组件里的事件方法名要和这里的方法名对应，绑定的属性名也要对应，主页面可以覆盖下面data里的page和pageSizes里的各个数值，但是名称不能改变
 *    @size-change="handleSizeChange"
 *    @current-change="handleCurrentChange"
 *    :current-page="page.pageNum"
 *    :page-sizes="pageSizes"
 *    :total="page.total"
 * 4. setTotal：主页面可以自己从查询返回的信息里去取总条数，也可以通过setTotal方法来给page里total赋值
 */
export default {
  data() {
    return {
      page: { page: 1, size: 20, totalElements: 0 },
      pageSizes: [20, 50, 100, 200]
    }
  },
  methods: {
    mergePage(data) {
      const page = { page: this.page.page, size: this.page.size }
      return Object.assign({}, data, page)
    },
    /**
     * 当切换每页显示的条数时，当前页是否小于等于最大页，如果是，返回true
     * @param val
     */
    lessThanMaxPage(val) {
      this.page.size = val
      const maxPage = Math.ceil(this.page.totalElements / val)
      if (maxPage >= this.page.page) {
        return true
      }
      // 将当前页换成计算后的最大页数，会触发当前页改变的方法
      this.page.page = maxPage
      return false
    },
    setTotal(data) {
      this.page.totalElements = data.total
    },
    /**
     * 查询按钮
     */
    getData() {
      this.page.page = 1
      this.queryList()
    },
    /**
     * 点击页数时的操作
     */
    handleSizeChange(val) {
      // 如果当前页小于等于最大页，当前页不会变动，因此需要主动触发逻辑
      if (this.lessThanMaxPage(val)) {
        this.queryList()
      }
    },
    /**
     *当前页改变时的操作
     */
    handleCurrentChange(page) {
      this.page.page = page;
      this.queryList()
    },
      clearPage() {
        this.page = { page: 1, size: 20, total: 0 }
      }
  }
}
